<template>
  <div>
    <AllPendingCases :selectedStatuses="statuses"></AllPendingCases>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllPendingCases = defineAsyncComponent(() =>
  import("@/components/pendingCases/AllApprovalPendingCases")
);
export default {
  components: {
    AllPendingCases,
  },
  data() {
    return {
      statuses: ["REJECTED"],
    };
  },
};
</script>
